<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ChangeSettlement')"
    :width="showBeforeAfter ? '420px' : '387px'"
    :close-on-click-modal="false"
    append-to-body
    class="settlement-select-dialog"
  >
    <div>
      <el-form label-width="90px" label-position="left">
        <template v-if="showBeforeAfter">
          <el-form-item :label="$t('CargoMsg.Cargo_BeforeAdjustment')">
            <cargo-advance-select
              no="beforeAccountId"
              filterable
              disabled
              :method-params="settlementMethodParams"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="beforeAccountId || ''"
              options-width="240px;"
              tag-name="chineseName"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AfterAdjustment')">
            <cargo-advance-select
              v-if="arSettlementUnitOptional && isAr"
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="accountId || ''"
              :method-params="settlementMethodParams"
              options-width="240px;"
              tag-name="chineseName"
              :static-options="companyFactorySigns"
              @parentCallBack="textAccountCode_changeHandler"
            />
            <cargo-sales-company-select
              v-else-if="accountObjectControlMode && isAr"
              :default-value="accountId || ''"
              options-width="240px;"
              @parentCallBack="textAccountCode_changeHandler"
            />
            <cargo-advance-select
              v-else
              no="accountId"
              filterable
              :method-params="settlementMethodParams"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="accountId"
              options-width="240px;"
              tag-name="chineseName"
              :data-filter-function="p => {
                if (isAr) {
                  return !!p.ifCustomer
                } else {
                  return !!p.ifSupplier
                }
              }"
              @parentCallBack="p=>accountId=p.cmpIdx"
            />
          </el-form-item>
        </template>
        <el-form-item v-else :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
          <cargo-advance-select
            v-if="arSettlementUnitOptional && isAr"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="accountId || ''"
            :method-params="settlementMethodParams"
            options-width="200px;"
            tag-name="chineseName"
            :static-options="companyFactorySigns"
            @parentCallBack="textAccountCode_changeHandler"
          />
          <cargo-sales-company-select
            v-else-if="accountObjectControlMode && isAr"
            :default-value="accountId || ''"
            options-width="200px;"
            @parentCallBack="textAccountCode_changeHandler"
          />
          <cargo-advance-select
            v-else
            no="accountId"
            filterable
            :method-params="settlementMethodParams"
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="accountId"
            :data-filter-function="p => {
              if (isAr) {
                return !!p.ifCustomer
              } else {
                return !!p.ifSupplier
              }
            }"
            @parentCallBack="p=>accountId=p.cmpIdx"
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" no="1" @click="selectOk">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="2" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ChangeAccountIdDialog',
  components: { CargoSalesCompanySelect, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    isAr: { type: Boolean, required: true },
    companyFactorySigns: { type: Array, required: false, default: () => [] },
    defaultAccountId: { type: Number, default: 0 },
    required: { type: Boolean, default: false },
    showBeforeAfter: { type: Boolean, default: false },
    beforeAccountId: { type: Number, default: 0 },
    settlementActiveOnly: { type: Boolean, default: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      accountObjectControlMode: false,
      arSettlementUnitOptional: false,
      accountId: null
    }
  },
  computed: {
    settlementMethodParams() {
      return this.settlementActiveOnly ? { active: true } : {}
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        await this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.accountId = null
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
  },
  methods: {
    async onShow() {
      await cache.load(cacheName.CONFIG)
      this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      if (this.defaultAccountId) {
        this.accountId = this.defaultAccountId
      }
    },
    async textAccountCode_changeHandler(result) {
      if (result) {
        this.accountId = result.cmpIdx
      }
    },
    selectOk() {
      if (this.required && !this.accountId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_SettleAccountsTo'))
        return
      }
      this.$emit('changeAccountId', { accountId: this.accountId || 0, isAr: this.isAr })
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.settlement-select-dialog {
  .ag-header {
    display: none;
  }
}
</style>
